import React from 'react';

import Modal from 'react-bootstrap/Modal';

export default function CustomModal({id, title, body, handleClose, show, className}) {
    return (
        <Modal id={id} show={show} onHide={handleClose} className={className}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
        </Modal>
    );
}